module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-field', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": _vm.open
    }
  }, [_vm._v("\n                Launch loading\n            ")])]), _vm._v(" "), _c('b-field', [_c('b-switch', {
    model: {
      value: (_vm.isFullPage),
      callback: function($$v) {
        _vm.isFullPage = $$v
      },
      expression: "isFullPage"
    }
  }, [_vm._v("Display loader over full page")])], 1), _vm._v(" "), _c('b-notification', {
    ref: "element",
    attrs: {
      "closable": false
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n        ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db0cfd9c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/loading/examples/ExProgrammatically.vue
// module id = 1107
// module chunks = 31 125